/**
 * Chinese translations for the free test feature
 */
const freeTest = {
  freeTest: {
    // Free test page
    title: "紫微斗数免费测试",
    subtitle: "免费体验紫微斗数命盘解析！",
    limitedTime: "免费测试 - 无需注册账户",
    aboutTitle: "关于此免费测试",
    aboutDescription: "此免费测试让您无需创建账户即可体验紫微斗数命盘分析的强大功能。",
    whatYouGet: "您将获得什么",
    feature1: "完整的紫微斗数命盘可视化",
    feature2: "基本性格分析",
    feature3: "生活领域概览",
    fullFeatures: "想要完整功能？",
    upgradeDescription: "创建账户以保存多个命盘，获取详细分析等更多功能。",
    signUpCta: "立即注册",
    tryAgain: "重试",

    // Free result page
    resultTitle: "免费命盘结果",
    resultTitleSuffix: "的免费命盘结果",
    resultSubtitle: "紫微斗数免费测试结果",
    upgradeTitle: "解锁完整分析",
    upgradeBenefits: "创建账户以访问完整分析，保存多个命盘，以及更多功能！",
    createAccount: "创建免费账户",
    createAnother: "创建另一个命盘",
    previewVersion: "预览版",
    limitedAnalysis: "有限预览分析",
    limitedAnalysisDesc: "此免费测试提供基本分析的预览。创建账户以解锁您命盘的完整详细分析和解读。",
    unlockFull: "解锁完整分析",
    moreAvailable: "更多分析可用",
    moreAnalysisDesc: "创建账户以解锁详细分析，包括四大主星宫位分析、事业洞察、关系兼容性等更多内容。",
    createAccountCta: "立即创建免费账户",

    // Error messages (free-result page)
    errorNotFound: "找不到此命盘。",
    errorLoadFailed: "命盘数据加载失败。",
    errorCalculationFailed: "命盘计算失败。",
    errorExpired: "此命盘可能已过期或已被移除。",
  },
  
  // Free test ended page
  freeTestEnded: {
    title: "免费测试暂不可用",
    description: "免费测试当前不可用。感谢您对我们紫微斗数命盘分析的关注！",
    whatNow: "现在怎么办？",
    createAccount: "您仍可以通过创建账户访问我们所有的功能。我们的完整版提供：",
    feature1: "完整的紫微斗数命盘可视化和分析",
    feature2: "为您自己和他人保存多个配置文件",
    feature3: "详细的性格分析和人生预测",
    feature4: "导出和分享您的命盘结果",
    signUpCta: "创建账户",
    signInCta: "登录",
    questions: "问题或反馈？",
    contactUs: "联系我们",
  },
  
  // Free test not started page
  freeTestNotStarted: {
    title: "免费测试即将推出",
    description: "我们的促销免费测试即将推出。请稍后再来查看！",
  },
  
  // Free test disabled page
  freeTestDisabled: {
    title: "免费测试暂不可用",
    description: "免费测试功能当前已禁用。请通过微信联系我们了解更多关于我们服务的信息。",
  },
  
  // Promotional component
  freeTestPromo: {
    limitedOffer: "免费测试",
    daysLeft: "无需注册",
    title: "免费紫微斗数命盘解读",
    description: "免费体验紫微斗数命盘分析的强大功能。无需账户！",
    tryNow: "立即尝试",
    createAccount: "创建完整账户",
  }
};

export default freeTest; 